import YGCClassPage from "./YGCClassPage";

const MEMBERS = [
  { name: "Yajath Narra", image: "/images/base/Contact-1.png" },
  { name: "Umika Kuricheti", image: "/images/base/Contact-1.png" },
  { name: "Soren Gjesfjeld", image: "/images/base/Contact-1.png" },
  { name: "Shruthi Vudaru", image: "/images/base/Contact-1.png" },
  { name: "Samuel Jackson", image: "/images/base/Contact-1.png" },
  { name: "Manjari Dheepan", image: "/images/base/Contact-1.png" },
  { name: "Hannah Gaff", image: "/images/base/Contact-1.png" },
  { name: "Diego Gonzalez", image: "/images/base/Contact-1.png" },
  { name: "Adi Menon", image: "/images/base/Contact-1.png" },
];

export default function Ygc2021() {
  return (
    <YGCClassPage
      year="2021"
      logoSrc="/images/ygc/2021/YGC_2021.jpg"
      members={MEMBERS}
    />
  );
}